import React from "react";
import { SOCIAL_LINKS } from "../../constants";
import SocialCards from "../social/SocialCards";
import NavigationCard from "../ui-kit/cards/NavigationCard";
import Header from "../ui-kit/header/Header";
import CourseIconSvg from "../ui-kit/icons/CourseIconSvg";
import PodcastIconSvg from "../ui-kit/icons/PodcastIconSvg";
import {
  DiscordSvg,
  InstagramSvg,
  TwitterSvg,
  YouTubeSvg,
} from "../ui-kit/icons/SocialSvg";
import useAmplitude from '../../contexts/AmplitudeContext'
import { AMPLITUDE_EVENTS } from '../../constants';

const IconContainer = ({ children, bg }) => {
  return (
    <span
      className={`${bg} w-12 h-12 flex justify-center items-center rounded-xl`}
    >
      {children}
    </span>
  );
};

const socialNetworksCards = [
  {
    data: {
      title: "Podcast",
      tag: "Entrevista con programadores y más",
    },
    icon: (
      <IconContainer bg="bg-highlight-yellow">
        <PodcastIconSvg className="w-8 h-8" />
      </IconContainer>
    ),
    href: SOCIAL_LINKS.podcast
  },
  {
    data: {
      title: "Instagram",
      tag: "Posts sobre programación, trabajo y motivación",
    },
    icon: (
      <IconContainer bg="bg-ig-purple">
        <InstagramSvg className="fill-current text-white w-8 h-8" />
      </IconContainer>
    ),
    href: SOCIAL_LINKS.instagram,
  },
  {
    data: {
      title: "Cursos Codealo",
      tag: "Aprende Git y GitHub | APIs REST con NodeJS y Express",
    },
    icon: (
      <IconContainer bg="bg-green-courses">
        <CourseIconSvg className="fill-current text-white w-8 h-8" />
      </IconContainer>
    ),
    href: SOCIAL_LINKS.thinkific,
  },
  {
    data: {
      title: "Youtube",
      tag: "Tutoriales, cursos y directos sobre programación",
    },
    icon: (
      <IconContainer bg="bg-yt-main">
        <YouTubeSvg className="fill-current text-white w-8 h-8" />
      </IconContainer>
    ),
    href: SOCIAL_LINKS.youtube,
  },
  {
    data: {
      title: "Twitter",
      tag: "Entérate de todas las actualizaciones de Codealo",
    },
    icon: (
      <IconContainer bg="bg-twitter-main">
        <TwitterSvg className="fill-current text-white w-8 h-8" />
      </IconContainer>
    ),
    href: SOCIAL_LINKS.twitter,
  },
  {
    data: {
      title: "Discord",
      tag: "Únete a la comunidad de 400+ miembros",
    },
    icon: (
      <IconContainer bg="bg-discord-main">
        <DiscordSvg className="fill-current text-white w-8 h-8" />
      </IconContainer>
    ),
    href: SOCIAL_LINKS.discord,
  },
];

const SocialNetworksSection = () => {
  const { amplitude } = useAmplitude();

  const eventLogger = (title: string) => { 
      amplitude.logEvent(AMPLITUDE_EVENTS.SOCIAL_NETWORK_CLICK, 
      { "social_network": title })}

  return (
    <section>
      <Header as="h2" className="text-primary">
        Mantente al día
      </Header>
      {/* <SocialCards /> */}
      <div className="pb-8 grid grid-flow-col grid-cols-1 sm:grid-cols-2 grid-rows-6 sm:grid-rows-3 gap-4 lg:gap-8 mt-4 overflow-hidden xl:-mx-8 xl:px-8">
        {socialNetworksCards.map((x, idx) => <NavigationCard {...x} eventLogger={eventLogger} key={idx}/>)}
      </div>
    </section>
  );
};

export default SocialNetworksSection;
